const React = require('react');
const {displayAmountAdmin, displayAmountMerchant} = require('../../utils/displayAmountData');
const {TableItemWithSubtitle} = require("../../../../helpers/Display");

const displayAmountFCCtor = (C) => ({fiat = {}, crypto = {}}) => {
  return (
    <TableItemWithSubtitle
      item={(
        <C {...fiat} type="fiat" />
      )}
      subItem={
        crypto.amount && crypto.symbol && (
          <C {...crypto} type="coin" />
        )
      }
    />
  )
};

module.exports = {
  DisplayAmountFCAdmin: displayAmountFCCtor(displayAmountAdmin),
  DisplayAmountFCMerchant: displayAmountFCCtor(displayAmountMerchant)
};
